/**
 * Onglet Configuration de l'application (admin)
 * @module admin/tabs/ApplicationTab
 */

import React from 'react';
import { useAppConfig } from '../hooks/useAppConfig';
import AdminResult from '../components/AdminResult';

const ApplicationTab = () => {
  const {
    config,
    loading,
    saving,
    error,
    fetchConfig,
    updateConfig,
  } = useAppConfig();

  const handleToggle = async (key, value) => {
    const updates = { [key]: value };
    const result = await updateConfig(updates);
    if (result.success) {
      // Feedback visuel géré par le state
    }
  };

  if (loading) {
    return (
      <section className="admin-section">
        <h2>⚙️ Configuration de l&apos;application</h2>
        <p className="admin-loading">Chargement...</p>
      </section>
    );
  }

  return (
    <section className="admin-section">
      <h2>⚙️ Configuration de l&apos;application</h2>
      <p className="admin-section-description">
        Activez ou désactivez la création de compte et les paiements sur l&apos;application.
      </p>

      {error && (
        <AdminResult isSuccess={false} title="Erreur" message={error} />
      )}

      {config && (
        <div className="admin-app-config">
          <div className="admin-config-item">
            <div className="admin-config-label">
              <strong>Création de compte</strong>
              <span className="admin-config-hint">
                Permet aux visiteurs de s&apos;inscrire via email ou Twitch
              </span>
            </div>
            <label className="admin-toggle">
              <input
                type="checkbox"
                checked={config.accountCreationEnabled}
                onChange={(e) =>
                  handleToggle('accountCreationEnabled', e.target.checked)
                }
                disabled={saving}
              />
              <span className="admin-toggle-slider" />
            </label>
          </div>

          <div className="admin-config-item">
            <div className="admin-config-label">
              <strong>Paiements (Premium)</strong>
              <span className="admin-config-hint">
                Permet les abonnements (Stripe) et les demandes d&apos;essai gratuit
              </span>
            </div>
            <label className="admin-toggle">
              <input
                type="checkbox"
                checked={config.paymentsEnabled}
                onChange={(e) =>
                  handleToggle('paymentsEnabled', e.target.checked)
                }
                disabled={saving}
              />
              <span className="admin-toggle-slider" />
            </label>
          </div>

          <div className="admin-config-item">
            <div className="admin-config-label">
              <strong>Mode maintenance</strong>
              <span className="admin-config-hint">
                Affiche une page de maintenance à tous les visiteurs (sauf les admins)
              </span>
            </div>
            <label className="admin-toggle">
              <input
                type="checkbox"
                checked={config.maintenanceMode}
                onChange={(e) =>
                  handleToggle('maintenanceMode', e.target.checked)
                }
                disabled={saving}
              />
              <span className="admin-toggle-slider" />
            </label>
          </div>
        </div>
      )}

      <button
        className="admin-button admin-button-secondary"
        onClick={fetchConfig}
        disabled={loading}
      >
        Actualiser
      </button>
    </section>
  );
};

export default ApplicationTab;
